<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />

    <b-row class="p-5" style="height: calc(100vh - 100px);overflow-y:auto;">
      <b-col cols="12">
        <h3>
          False Positive Report Remediation&nbsp;
          <small class="text-muted">OGM</small>
        </h3>
        <b-tabs>
          <b-tab title="Alerted entity overview">
            <b-row class="p-5">
              <b-col cols="3">
                <b-card>
                  <b-card-text>
                    <strong>Date:</strong>
                    <br />
                    {{ setDateFormat(ogm.created_at) }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Report Type:</strong>
                    <br />
                    OGM - {{ogm.product_type == 1 ? 'Instant Due Diligence' : 'Instant Due Diligence Plus' }}
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="3">
                <b-card>
                  <b-card-text v-if="dataLoaded">
                    <strong>Third Party Name:</strong>
                    <br />
                    {{ogm.shield_vendor_info && ogm.shield_vendor_info.comp_name_eng || ''}}
                  </b-card-text>
                  <b-card-text v-if="dataLoaded">
                    <strong>Jurisdiction:</strong>
                    <br />
                    {{ogm.shield_vendor_info && ogm.shield_vendor_info.country || 'All'}}
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="3">
                <b-card>
                  <b-card-text>
                    <strong>Entity Type:</strong>
                    <br />
                    <font-awesome-icon
                      v-if="dataLoaded"
                      :icon="ogm.shield_vendor_info && ogm.shield_vendor_info.search20_tpi.entity_type== 'company' ? 'building' : 'male'"
                      class="mr-2"
                    />
                  </b-card-text>
                  <b-card-text>
                    <strong>Number of Alerts</strong>
                    <br />
                    <span
                      v-if="dataLoaded"
                    >{{ogm.rdc_monitoring_entity_report_alert && ogm.rdc_monitoring_entity_report_alert.length || 0}}</span>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="3">
                <b-card v-if="dataLoaded && !reportStatus">
                  <b-card-text v-if="dataLoaded">
                    <strong>Negative Alerts:</strong>
                    <br />0
                  </b-card-text>
                  <b-card-text v-if="dataLoaded">
                    <strong>Positive Alerts:</strong>
                    <br />0
                  </b-card-text>
                </b-card>
                <b-card v-if="dataLoaded && reportStatus">
                  <b-card-text v-if="dataLoaded">
                    <strong>Completed On</strong>
                    <br />
                    {{ogm.completed_at}}
                  </b-card-text>
                  <b-card-text v-if="dataLoaded">
                    <strong>Outcome</strong>
                    <br />
                    <b-badge variant="danger">POSITIVE</b-badge>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <div v-for="(alert,index) in ogm.rdc_monitoring_entity_report_alert" :key="index">
              <rdc-alert-ogm :alert="alert" :alertIndex="index" :reportStatus="reportStatus"></rdc-alert-ogm>
            </div>
          </b-tab>
          <b-tab title="Entity alert history">
            <b-row class="p-5">
              <b-col cols="12">
                <b-navbar toggleable="lg" type="dark" variant="light">
                  <b-navbar-brand href="#" class="text-dark">
                    <strong>Entity Alert History</strong>
                  </b-navbar-brand>
                  <b-navbar-nav class="ml-auto">
                    <b-nav-form>
                      <b-form-group
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-nav-form>
                  </b-navbar-nav>
                </b-navbar>
                <b-table
                  class="mx-1"
                  sticky-header="calc(100vh - 200px)"
                  ref="table"
                  bordered
                  id="my-table"
                  :busy.sync="isLoading"
                  :items="getEntityPreviousOgmAlerts"
                  :fields="entityAlertHistoryFields"
                  :filter="filter"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive="sm"
                ></b-table>
                <b-row>
                  <b-col cols="2">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                    <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      aria-controls="my-table"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

    <b-navbar
      toggleable="lg"
      type="dark"
      variant="dark"
      fixed="bottom"
      v-if="dataLoaded && !reportStatus"
    >
      <b-navbar-brand href="#">Total Alerts: {{$store.state.totalAlerts}}</b-navbar-brand>
      <b-navbar-brand href="#">Remediated Alerts: {{$store.state.totalRemidiatedAlerts}}</b-navbar-brand>
      <b-navbar-brand href="#">Pending: {{$store.state.totalPendingAlerts}}</b-navbar-brand>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              v-if="status == 2"
              size="sm"
              class="m-2 my-sm-0"
              variant="outline-danger"
              @click="failReview"
            >Fail Review</b-button>
            <b-button
              :disabled="$store.state.totalRemidiatedAlerts != 0"
              v-if="status == 0"
              size="sm"
              class="m-2 my-sm-0"
              variant="outline-warning"
              @click="submitReview"
            >Submit for review</b-button>
            <b-button
              :disabled="$store.state.totalRemidiatedAlerts != 0 && status == 0"
              size="sm"
              class="m-2 my-sm-0"
              variant="outline-success"
              @click="publishClientSubmit"
            >{{ status == 0 ? 'Publish to client' : 'Approve' }}</b-button>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      scrollable
      size="lg"
      v-model="alertSaveModal"
      :title="review ? 'Submit For Review Remediated OGM Alert' : 'Complete Remediated OGM Alert'"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-collapse v-model="publishClient">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Select Client Emails">
                  <v-select
                    :searchable="true"
                    :clearable="true"
                    :multiple="true"
                    label="label"
                    code="value"
                    aria-describedby
                    v-model="selectedClientEmails"
                    :options="clientEmailOptions"
                    @input="onSelectClientEmail"
                    placeholder="Select Client Email"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Select Ethixbase User Emails">
                  <v-select
                    :searchable="true"
                    :clearable="true"
                    :multiple="true"
                    label="label"
                    code="value"
                    aria-describedby
                    v-model="selectedEthixbaseUserEmail"
                    :options="ethixbaseUserEmailOptions"
                    @input="onSelectEthixbaseUserEmail"
                    placeholder="Select Ethixbase User Email"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group>
              <b-form-radio-group
                v-model="customMessageSelected"
                :options="customMessageOptions"
                @input="customMessageInput"
              ></b-form-radio-group>
            </b-form-group>
          </b-collapse>
          <b-collapse v-model="customMessageEditior">
            <b-form-group :label="customMessageSelected">
              <wysiwyg v-model="customMessage" />
            </b-form-group>
          </b-collapse>
          <b-collapse v-model="review">
            <b-form-group label="Assign to reviewer">
              <v-select
                :searchable="true"
                :clearable="true"
                label="label"
                code="value"
                aria-describedby
                :class="$v.selectedEmployee.$error ? 'border border-danger rounded' : null"
                v-model="$v.selectedEmployee.$model"
                :state="$v.selectedEmployee.$dirty ? !$v.selectedEmployee.$error : null"
                :options="employeesOptions"
                placeholder="Select Employee"
              ></v-select>
            </b-form-group>
          </b-collapse>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Completing Remediation Alerts......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Remediation Alerts Completed.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" v-if="!submiting" @click="resetModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="completeRemediationAlerts()"
        >Complete</b-button>
      </template>
    </b-modal>
    <b-overlay :show="showFailReview" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Disapproving...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="showFailReview = false">Cancel</b-button>
            <b-button variant="outline-danger" @click="failAlertReviewCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import AppLoader from "../components/Loader/Loader";

import rdcAlertOgm from "@/components/remediation/RDCOgmAlert.vue";
import vSelect from "vue-select";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import _ from "lodash";
import moment from "moment";
import "moment/locale/es";

export default {
  name: "remediationAsAServiceOgmAlert",
  mixins: [validationMixin],
  components: {
    rdcAlertOgm,
    AppLoader
  },
  data() {
    return {
      showFailReview: false,
      responseSuccess: false,
      submiting: false,
      alertSaveModal: false,
      customMessageSelected: null,
      customMessageOptions: [
        { text: "Append Custom Message", value: "Append Custom Message" },
        { text: "Override Custom Message", value: "Override Custom Message" }
      ],
      customMessage: null,
      customMessageEditior: false,
      publishClient: false,
      review: false,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "completed_by_id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      filter: null,
      entityAlertHistoryItems: [],
      entityAlertHistoryFields: [
        {
          key: "created_at",
          label: "age",
          sortable: true
        },
        {
          key: "completed_by_id",
          label: "Remediated by",
          sortable: true
        },
        {
          key: "completed_at",
          label: "Completed On",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "outcome",
          label: "Outcome",
          sortable: true
        },
        {
          key: "download",
          label: "Download",
          sortable: true
        },
        {
          key: "action",
          label: "Actions",
          sortable: false
        }
      ],
      selectedEmployee: null,
      employeesOptions: [],
      isLoading: false,
      dataLoaded: false,
      ogm: {},

      //for entities with alert

      totalAlerts: 0,
      status: null,
      reportStatus: false,
      processing: false,
      counter: 1,
      interval: null,
      anyError: false,
      companyId: null,
      clientEmailOptions: [],
      selectedClientEmails: [],
      selectedClientEmailsValues: [],
      ethixbaseUserEmailOptions: [],
      selectedEthixbaseUserEmail: [],
      selectedEthixbaseUserEmailValues: []
    };
  },
  validations: {
    selectedEmployee: { required }
  },
  mounted() {
    this.getEmployeeOptions();
    this.getEntityOgmAlerts(this.$route.params.id);
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    submitReview() {
      this.alertSaveModal = true;
      this.review = true;
    },
    publishClientSubmit() {
      this.alertSaveModal = true;
      this.publishClient = true;
    },
    failReview() {
      this.showFailReview = true;
      this.processing = false;
    },
    customMessageInput() {
      if (this.customMessageSelected) {
        this.customMessageEditior = true;
      } else {
        this.customMessageEditior = false;
      }
    },
    async getEntityOgmAlerts(id) {
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.items = [];
      this.$store.state.totalPendingAlerts = 0;
      this.$store.state.totalAlerts = 0;
      this.$store.state.totalRemidiatedAlerts = 0;

      this.totalAlerts = 0;
      try {
        this.isLoading = true;
        let result = await HTTP(
          "get",
          "v1/remediation/ogm/entity/alerts/" + id,
          {},
          {
            Authorization: token
          },
          null,
          true
        );
        this.ogm = result.data; //  get an object in response
        this.status = result.data.status;
        this.reportStatus = result.data.status == 1 ? true : false;

        this.dataLoaded = true;
        if (this.ogm.rdc_monitoring_entity_report_alert.length > 0) {
          this.$store.state.totalAlerts += this.ogm.rdc_monitoring_entity_report_alert.length; // sum of investments in store
          this.totalAlerts += this.ogm.rdc_monitoring_entity_report_alert.length; // sum of investments

          this.$store.state.totalPendingAlerts += this.ogm.rdc_monitoring_entity_report_alert.length; // sum of investments in store
        }

        this.isLoading = false;
        this.getCompanyEmail(result.data.company_id);
      } catch {
        this.isLoading = false;
        this.showErrorToast = true;
      }
    },
    async getEntityPreviousOgmAlerts() {
      let formData = {
        rdc_monitoring_entity_report_id: this.$route.params.id
      };
      this.items = [];
      this.$store.state.totalPendingAlerts = 0;
      this.$store.state.totalAlerts = 0;
      this.$store.state.totalRemidiatedAlerts = 0;

      this.totalAlerts = 0;
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP(
        "post",
        "v1/remediation/ogm/entity/previous/alerts",
        formData,
        {
          Authorization: token
        }
      );

      return result
        .then(response => {
          const items = response.data;
          // this.entityAlertHistoryItems = response.data; //  get an object in response

          this.dataLoaded = true;
          if (this.ogm.rdc_monitoring_entity_report_alert.length > 0) {
            this.$store.state.totalAlerts += this.ogm.rdc_monitoring_entity_report_alert.length; // sum of investments in store
            this.totalAlerts += this.ogm.rdc_monitoring_entity_report_alert.length; // sum of investments

            this.$store.state.totalPendingAlerts += this.ogm.rdc_monitoring_entity_report_alert.length; // sum of investments in store
          }

          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          this.showErrorToast = true;
          return [];
        });
    },

    async submitAlert() {
      let id = this.$route.params.id;
      let token = "Bearer " + localStorage.getItem("accessToken");

      try {
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/remediation/ogm/entity/alert/submit",
          {
            id: id,
            publish_to_client: null,
            publish_for_review: null,
            reviewer_id: null,
            report_result: null
          },
          {
            Authorization: token
          },
          null,
          true
        );
      } catch {
        this.showErrorToast = true;
      }
    },
    completeRemediationAlerts() {
      if (this.review) {
        this.$v.$touch();
        if (this.$v.$anyError) {
          return;
        } else {
          this.submitForReviewCall();
        }
      } else {
        this.completeRemediationAlertsCall();
      }
    },
    async completeRemediationAlertsCall() {
      let formData = {
        rdc_monitoring_entity_report_id: this.$route.params.id,
        completed_at: new Date(),
        third_party_id: this.ogm.shield_vendor_info
          ? this.ogm.shield_vendor_info.id
          : 0,
        client_email_address: this.selectedClientEmailsValues,
        ethixbase_user_email_address: this.selectedEthixbaseUserEmailValues,
        completed_by_id: localStorage.getItem("userId"),
        custom_message_value: this.customMessageSelected,
        custom_message: this.customMessage
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP("post", "v1/remediation-ogm/complete", formData, {
          Authorization: token
        });
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        return [err];
      }
    },
    async submitForReviewCall() {
      let formData = {
        rdc_monitoring_entity_report_id: this.$route.params.id,
        reviewer_id: this.selectedEmployee.value
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP("post", "v1/remediation-ogm/submit-for-review", formData, {
          Authorization: token
        });
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        return [err];
      }
    },
    resetModal() {
      this.customMessageSelected = null;
      this.customMessage = null;
      this.customMessageEditior = false;
      this.publishClient = false;
      this.review = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
      this.alertSaveModal = false;
      this.selectedEmployee = null;
      this.$v.$reset();
    },
    setDateFormat(value) {
      moment.locale("en");
      let date = value ? value : null;
      return moment(date).format("DD dddd MMMM YYYY HH:mm");
    },
    async getEmployeeOptions() {
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        let result = await HTTP("get", "v1/employee-options", null, {
          Authorization: token
        });
        this.employeesOptions = result.data.employee;
      } catch (error) {
        this.isLoading = false;
      }
    },
    failAlertReviewCall() {
      this.counter = 1;
      this.processing = true;
      this.failAlertReview().then(
        this.getEntityOgmAlerts(this.$route.params.id)
      );
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showFailReview = this.processing = false;
          });
        }
      }, 350);
    },
    async failAlertReview() {
      let formData = {
        rdc_monitoring_entity_report_id: this.$route.params.id
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP("post", "v1/remediation-ogm/fail-review", formData, {
          Authorization: token
        });
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        return [err];
      }
    },
    async getCompanyEmail(company_id) {
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        let result = await HTTP(
          "get",
          "v1/remediation/get-company-email/" + company_id,
          null,
          {
            Authorization: token
          }
        );
        if (result.data.client_emails != []) {
          this.clientEmailOptions = [];
          for (let i = 0; i < result.data.client_emails.length; i++) {
            this.clientEmailOptions.push({
              label: result.data.client_emails[i].name,
              value: result.data.client_emails[i].email
            });
          }
        }
        if (result.data.ethixbase_emails != []) {
          this.ethixbaseUserEmailOptions = [];
          for (let i = 0; i < result.data.ethixbase_emails.length; i++) {
            this.ethixbaseUserEmailOptions.push({
              label: result.data.ethixbase_emails[i].name,
              value: result.data.ethixbase_emails[i].email
            });
          }
        }
      } catch (error) {
        this.isLoading = false;
      }
    },
    onSelectClientEmail(data) {
      this.selectedClientEmailsValues = [];
      for (let i = 0; i < data.length; i++) {
        this.selectedClientEmailsValues.push(data[i].value);
      }
    },
    onSelectEthixbaseUserEmail(data) {
      this.selectedEthixbaseUserEmailValues = [];
      for (let i = 0; i < data.length; i++) {
        this.selectedEthixbaseUserEmailValues.push(data[i].value);
      }
    }
  }
};
</script>

<style scoped>
.pri-row {
  height: calc(100vh - 150px);
  overflow-y: scroll;
}
</style>
